import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import { ProductionShopFloorWorkOrders } from 'src/app/services/service/DataProviders/ProductionShopFloorWorkOrders';
import { PoTree } from '../po-tree/potree/po-tree';
import jsPDF from 'jspdf'
import autoTable, { Styles } from 'jspdf-autotable'
import roboto from './roboto';
import * as moment from 'moment';

@Component({
  selector: 'po-work-cards',
  templateUrl: './po-work-cards.component.html',
  styleUrls: ['./po-work-cards.component.scss'],
})
export class PoWorkCardComponent {

  @Input() wo: any[] = [];
  public po = null;
  public treeForView: any = [];

  private styles = <Styles>{ halign: 'center', font: 'Roboto-Regular', fontSize: 14 };
  private maxLevel = 0;

  constructor(private woService: ProductionShopFloorWorkOrders) { }

  ngOnChanges(sc: SimpleChange) {
    const currentValue = _.get(sc, 'wo.currentValue');
    if (!_.isNull(currentValue)) {
      this.po = currentValue;
      this.initTree();
    }
  }

  async initTree() {
    const poTree = new PoTree(this.woService);
    const masterNode = await poTree.buildTree(this.po);
    this.maxLevel = await poTree.getMaxLevel();
    this.treeForView = [this.buildTreeForFE(masterNode, poTree)];

    const doc = new jsPDF({
      unit: 'mm',
      format: 'a2',
    });

    doc.addFileToVFS('Roboto-Regular-normal.ttf', roboto);
    doc.addFont('Roboto-Regular-normal.ttf', 'Roboto-Regular', 'normal');
    doc.setFont("Roboto-Regular");

    let header = [
      { content: 'Продукт', styles:{ ...this.styles, cellWidth: 90} },
      { content: 'детайли бр.', styles:{ ...this.styles, cellWidth: 20} },
      { content: 'Работна карта', styles:{ ...this.styles, cellWidth: 35} },
      { content: 'Операция',styles:{ ...this.styles, cellWidth: 80} },
      { content: 'Оборудване', styles:{ ...this.styles, cellWidth: 'auto'} },
      { content: 'Време, мин', styles:{ ...this.styles, cellWidth: 30} },
    ];

    let body = [];

    for(let i = 0; i < this.treeForView.length; i++) {
      const rows = []
      const node = this.treeForView[i];
      this.toBody(node, rows);
      body.push(...rows);
    }

    const table = {
      head: [ this.addElementsOnFront(this.maxLevel, header) ],
      body,
    };

    autoTable(doc, table);

    const pageCount = doc.getNumberOfPages()

    doc.setFont('Roboto-Regular')
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      const orderNo = _.get(this.treeForView, '[0].node.po.CustomProperty_No_Order.Value', null);
      if(!_.isNull(orderNo)) {
        doc.setFontSize(18)
        doc.text('Поръчка No ' + orderNo, doc.internal.pageSize.width/2, 10, {
          align: 'center'
        });
      }

      doc.setFontSize(8)
      doc.text('Страница ' + String(i) + ' / ' + String(pageCount), doc.internal.pageSize.width - 20, doc.internal.pageSize.height - 7, {
        align: 'right'
      })
      doc.text('oтпечатано на: ' + moment().format('DD.MM.YYYY hh:mm:ss'), 20, doc.internal.pageSize.height - 7, {
        align: 'left'
      })
    }

    doc.save('table.pdf');
    // console.log(this.treeForView)
  }

  private addElementsOnFront(n, a, addNumber = false) {
    const collSpan = this.maxLevel - n + 1;
    a[0].colSpan = collSpan;

    for(let i = 0; i < n; i++) {
      const offset =  { content: '', styles:{ ...this.styles, cellWidth: 8} };

      if(addNumber && i === n-1) {
        if(n === 1) {
          offset.content = n;
        }
      }

      a.unshift(offset);
    }

    return a;
  }

  private toBody(n, rows) {
    const { node, children } = n;
    const documentNo = node.getDocumentNo();
    const { level, items } = node;

    for(let i = 0; i < items.length; i++) {
      const item = items[i];
      rows.push(this.addElementsOnFront(level, [
        { content: _.get(item, 'Product.Name.BG'), styles: {...this.styles, halign: 'left'} },
        { content: _.get(item, 'ProducedQuantity.Value') /*+ ' ' + _.get(item, 'ProducedQuantity.Unit')*/, styles: this.styles },
        { content: documentNo, styles: this.styles },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
      ], true));

      let note = _.get(item, 'Recipe.Notes', '');
      if(_.isNull(note)) {
        note = '';
      }
      rows.push(this.addElementsOnFront(level, [
        { content: note, styles: {...this.styles, halign: 'right' } },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
        { content: '', styles: this.styles },
      ]));

      //подреждам ги по номер на ред
      item.Operations = _.sortBy(item.Operations,'LineOrd')

      for(let j = 0; j < item.Operations.length; j++) {
        const o = item.Operations[j];
        rows.push(this.addElementsOnFront(level, [
          { content: '', styles: this.styles },
          { content: '', styles: this.styles },
          { content: '', styles: this.styles },
          { content: _.get(o, 'Operation.Name'), styles: {...this.styles, halign: 'left' } },
          { content: _.get(o, 'WorkgroupResource.Resource.Name'), styles: {...this.styles, halign: 'left' } },
          { content: _.get(o, 'RunTimeMinutes'), styles: this.styles },
        ]));
      }

      for(let j = 0; j < children.length; j++) {
        const c = children[j];
        this.toBody(c, rows)
      }
    }
  }

  private buildTreeForFE(node, poTree) {
    return {
      node,
      children: poTree.getSuccessors(node).map((n) => this.buildTreeForFE(
        n,
        poTree
      ))
    }
  }

  getChildrens = (node) => node.children;

}
